/** One row of GET /api/catalog/systems: an external data system and how it is set up. */
export interface SystemSummary {
  systemId: string;
  displayName: string;
  description: string;
  availability: 'available' | 'planned';
  status: 'ready' | 'needs_credential' | 'planned';
  tables: number;
  restrictedTables: number;
  apps: number;
  refreshedAt?: string;
}

/** Display names for system ids, for views that only have a source's connector id. */
export const SYSTEM_NAMES: Record<string, string> = {
  airtable: 'AirTable',
  workspan: 'WorkSpan',
  zenith: 'Zenith',
};

export const systemName = (id: string | undefined): string => (id ? (SYSTEM_NAMES[id] ?? id) : 'AirTable');
